import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { HeaderWithBackNavigation } from '@app/components/HeaderWithBackNavigation';
import { useShowAddonsShop } from '@app/hooks';
import { getAddOnOffers, refetchAddOnOffers, refetchCurrentAddOns, selectAddOns } from '@app/redux/addOns';

import AddonsDisclosures from './components/AddonsDisclosure';
import AddonsGrid from './components/AddonsGrid';
import SubscribedAddons from './components/SubscribedAddons';
import { useShouldRefetchCurrentAddons } from './hooks';
import { useSetAddOnConsent } from './hooks/use-addons-consent';

import styles from './index.module.scss';

const ShopAddons = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation('ShopAddons');

  const showAddonsShop = useShowAddonsShop();
  const {
    addOnOrderId,
    submitOrder,
    configureAddon,
    availableAddons: { productTypes = [] },
  } = useSelector(selectAddOns);
  const shouldRefetchCurrentAddOns = useShouldRefetchCurrentAddons();

  useEffect(() => {
    if (!showAddonsShop) {
      history.replace('/');
    }
  }, [history, showAddonsShop]);

  useEffect(() => {
    if (shouldRefetchCurrentAddOns) {
      dispatch(refetchCurrentAddOns(addOnOrderId as string));
    }
    if (addOnOrderId || submitOrder.error || configureAddon) {
      // Refetch to get a new offerId for the cart of the next order submission
      dispatch(refetchAddOnOffers());
    } else {
      dispatch(getAddOnOffers());
    }
  }, [shouldRefetchCurrentAddOns, addOnOrderId, submitOrder.error, configureAddon, dispatch]);

  // Set explicit consent for grouped product sub-types
  useSetAddOnConsent(productTypes);

  const navigateToPreviousPage = () => history.goBack();

  return (
    <div className={styles['layout']}>
      <div>
        <HeaderWithBackNavigation
          title={t('selectAddon.title')}
          handleBackNavigation={navigateToPreviousPage}
          goBackLabel={t('goBack')}
        />
      </div>
      <AddonsGrid />
      <div>
        <SubscribedAddons />
        <AddonsDisclosures />
      </div>
    </div>
  );
};

export default ShopAddons;
